import { HowWorksSectionProps } from "@models/blocks/how-it-works.interface";
import { IStartIntegrationSection } from "@models/blocks/start-integration.interface";
import { ITextSection } from "@models/blocks/text-section.interface";
import { IMetaData } from "@models/meta-data.interface";

export interface ISolutionDetailPage {
  title: string;
  metaData: IMetaData;
  previewSection: IPreviewSection;
  complianceSection: IComplianceSection;
  textSection: ITextSection;
  cryptoBenefitsSection: ICryptoBenefitsSection;
  howWorksSection: HowWorksSectionProps;
  startIntegrationSection?: IStartIntegrationSection;
}

export interface IPreviewSection {
  title: [string, string, string];
  subtitle: string;
  imgSrc: string;
  buttonText: string;
}

export interface IComplianceSection {
  title: [string, string, string];
  cards: IComplianceCard[];
}

export interface IComplianceCard {
  icon: string;
  title: string;
}

export enum SolutionSlug {
  GAMING = 'gaming',
  CRYPTO_EXCHANGES = 'crypto-exchanges',
  LIST_YOUR_TOKEN = 'list-your-token',
  ACCEPT_CRYPTO_DONATIONS = 'accept-crypto-donations',
  WHITELABEL = 'whitelabel',
  WEB3_KYC = 'web3-kyc',
  STAKING = 'staking',
}

export interface ICryptoBenefitsSection {
  title: [string, string, string];
  cards: ICryptoBenefitsCard[];
}

export interface ICryptoBenefitsCard {
  title: string;
  subtitle: string;
  icon: string;
  link: string;
  linkText: string;
}
